import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'eos-alert',
  templateUrl: './alert.component.html',
  encapsulation: ViewEncapsulation.None,
  styles: [`
    .custom-class.modal{
      z-index:9999;
    }
  `]
})
export class AlertComponent implements OnInit {
  @Input() public header: string;
  @Input() public isOkCancel: boolean = true;
  @Input() public isShareDocs: boolean=false;
  @Input() public isPopUp :boolean = false;
  content=''
  constructor(public modal: NgbActiveModal) { }

  ngOnInit() {
  }
}
